import { render, staticRenderFns } from "./navbar-boost-view.vue?vue&type=template&id=8a71c1a4&"
import script from "./navbar-boost-view.vue?vue&type=script&lang=ts&"
export * from "./navbar-boost-view.vue?vue&type=script&lang=ts&"
import style0 from "./navbar-boost-view.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports